import React, { useCallback } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Button } from "@design-system/Button/Button";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useOverlays } from "contexts/OverlayContext";
import { InvoiceTemplateRow } from "../invoiceTemplates.types";

// Count of invoices created from the template. Clicking it opens the invoices
// drawer filtered to that template (sourceTemplateIds).
export const InvoicesCell = React.memo(function InvoicesCell({
    row,
}: CellContext<ViewTableFeatures, InvoiceTemplateRow, number>) {
    const { openOverlay } = useOverlays();
    const templateId = row.original.id;
    const count = row.original.sourcedInvoiceCount;

    const handleClick = useCallback(
        (event: React.MouseEvent) => {
            event.stopPropagation();
            openOverlay("invoicesDrilldown", {
                filters: { sourceTemplateIds: [templateId] },
            });
        },
        [openOverlay, templateId],
    );

    return (
        <ViewTableCell captureClicks>
            <Button
                variant="secondary"
                size="sm"
                onClick={handleClick}
                disabled={count === 0}
            >
                {count}
            </Button>
        </ViewTableCell>
    );
});
